import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import CustomerTableRecords from '../CustomerTableRecords';

const InactiveCustomers = () => (
  <CustomerTableRecords defaultUrl={AdminRouteName.inactiveCustomersRoute} toggleStorageId="all_customer-table-col" hasNameAndImage permissionName="can-view-all-customer-tab" tabStatus="Declined" />
);
export default InactiveCustomers;
